"use strict";function openSystemSetting$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.openSystemSetting$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="device.base.openSystemSetting";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.android]={vs:"6.0.27"},_a[ddSdk_1.ENV_ENUM.ios]={vs:"6.3.15"},_a)),exports.openSystemSetting$=openSystemSetting$,exports.default=openSystemSetting$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/device/base/openSystemSetting.js
// module id = 1055
// module chunks = 106